import React from 'react'
import './TypingIndicatior.css'
function TypingIndicatior() {
    return (
        <div>
            <div className="ticontainer">
                <div className="tiblock">
                    <div className="tidot"></div>
                    <div className="tidot"></div>
                    <div className="tidot"></div>
                </div>
            </div>
        </div>
    )
}

export default TypingIndicatior